/* sm-faq.js
   Accordion for FAQ blocks marked data-sm-faq (snippets/sm-faq.liquid).
   One answer open at a time within each block; clicking an open question
   closes it. Uses one delegated listener, so blocks added later work too. */
(function () {
  if (window.SMFaq) return;
  window.SMFaq = true;

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-sm-faq] .sb') : null;
    if (!btn) return;
    var item  = btn.closest('.sf');
    var block = btn.closest('[data-sm-faq]');
    var wasOpen = item.classList.contains('open');
    Array.prototype.forEach.call(block.querySelectorAll('.sf.open'), function (x) {
      x.classList.remove('open');
      var b = x.querySelector('.sb');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
    }
  });
})();
